import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator"

overrideIfMinBetNumberEnabled(function () {

    $.extend(window.TResponsiveMultiOptions, {
        getUKBetsItemCssClass (options?: { isMinBetNumberValid }): string {
            var isValid = options ? options.isMinBetNumberValid : BetSlip.CurrentMode.areAllSinglesValid();
            return isValid  ? "" : "disabled";
        }
    });

});